import React from "react";
import { Header } from "@sunwing/components";
import { NavLink } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { withLocalizer } from "utilities/withLocalizer";

import "./appHeader.css";
import commonUtilities from "utilities/common";
import Moment from "moment";
import "moment/locale/fr";

const AppHeader = (props) => {
    const { authState, oktaAuth } = useOktaAuth();
    const auth = authState?.isAuthenticated;

    let userName = authState?.idToken?.claims?.name;
    let isIQMUser = false;

    isIQMUser = commonUtilities.isIQMUser();

    const handleLogOut = () => {
        commonUtilities.clearStorage();
        oktaAuth.signOut();
    };

    const language = commonUtilities.getLanguage();

    if (auth) {
        Moment.locale(language);

        const englishLinks = [
            {
                id: "1",
                linkText: "New group travel quote",
                target: "_self",
                url: "/home"
            },
            {
                id: "2",
                linkText: "Review all group quotes",
                target: "_self",
                url: "/review"
            }
        ];

        const frenchLinks = [
            {
                id: "1",
                linkText: "Nouveau devis de voyage de groupe",
                target: "_self",
                url: "/home"
            },
            {
                id: "2",
                linkText: "Revoir une Soumission déjà existant",
                target: "_self",
                url: "/review"
            }
        ];

        const links = language === "en" ? englishLinks : frenchLinks;

        return (
            <div className="row app-header" data-testid="header-component">
                <Header
                    data-testid="app-header"
                    currentLanguage="en"
                    languagePages={[]}
                    logoOnly={isIQMUser}
                    logo={
                        <img src="https://assets.sunwingtravelgroup.com/image/upload/v1614627905/sunwing-prod/Web%20Replatform%20Project/Logos/SunwingLogos/NewSunwingLogo-white.svg" alt="sunwing" />
                    }
                    links={links}
                    menuLinks={null}
                    profileData={{
                        isUserLoggedIn: false,
                        userName: userName
                    }}
                    renderLink={(link, { classNames }) => (
                        <NavLink to={link.url} className={(classNames.link, classNames.isActive)}>
                            {link.linkText}
                        </NavLink>
                    )}
                >
                    <div
                        className="user-menu"
                        slot="okta"
                    >
                        <div data-testid="logout-btn" onClick={handleLogOut}>{props.localize("qma-sign-out")}</div>
                    </div>
                </Header>
            </div>
        );
    }
};

export default withLocalizer(AppHeader);